
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/[slug]",
      function () {
        return require("private-next-pages/destinations/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/[slug]"])
      });
    }
  